module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "text-align: left;"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [_c('h3', [_c('small', [_c('span', {
    class: _vm.statusClass()
  }, [_vm._v(_vm._s(_vm.actionData.status) + ": ")]), _c('i', {
    class: _vm.actionData.workflow.icon
  }), _vm._v(" " + _vm._s(_vm.actionData.workflow.name) + ":")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.actionData.site.siteName))]), _vm._v(" | "), _c('i', {
    class: 'fa fa-' + _vm.statusIcon() + ' ' + _vm.statusClass()
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_c('small', [_vm._v("by:")]), _vm._v(" "), _c('b', {
    class: _vm.statusClass()
  }, [_vm._v(_vm._s(_vm.actionData.organisation.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.actionData.completed_at || _vm.actionData.completed_by) ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n          " + _vm._s(_vm.actionData.actionType) + " completed \n          "), (_vm.actionData.completed_at) ? _c('span', [_vm._v("on "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.actionData.completed_at)))])]) : _vm._e(), _vm._v(" "), (_vm.actionData.completed_by) ? _c('span', [_vm._v(" by "), _c('b', [_vm._v(_vm._s(_vm.actionData.completed_by))])]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', [(_vm.actionData.parties > 1) ? _c('div', [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, _vm._l((_vm.actionData.parties), function(partyNo) {
    return _c('el-tab-pane', {
      key: partyNo,
      attrs: {
        "label": _vm.partyName(partyNo)
      }
    }, [_c('files-table', {
      attrs: {
        "title": _vm.partyName(partyNo),
        "id": _vm.getFileTableRef(partyNo),
        "name": _vm.getFileTableRef(partyNo),
        "table-ref": 'filestable' + partyNo,
        "site-id": _vm.actionData.site_id,
        "type": _vm.actionData.actionType.toLowerCase(),
        "type-id": _vm.actionData.id,
        "partyNo": partyNo,
        "disable-form": true,
        "size": "text",
        "show-file-name": false,
        "show-refresh": false,
        "show-search": false
      }
    })], 1)
  }), 1)], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.steps && _vm.steps[0].comp) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.accordion),
      callback: function($$v) {
        _vm.accordion = $$v
      },
      expression: "accordion"
    }
  }, _vm._l((_vm.steps), function(s, index) {
    return _c('el-collapse-item', {
      key: s.title,
      attrs: {
        "name": '' + index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('b', {
      staticClass: "text-primary"
    }, [_c('i', {
      class: s.icon
    }, [_vm._v(" ")]), _vm._v(_vm._s(s.title))])]), _vm._v(" "), _c('el-form', [(_vm.actionData && s.comp && s.data) ? _c(s.comp, _vm._b({
      tag: "component"
    }, 'component', s.data, false)) : _vm._e()], 1)], 2)
  }), 1) : _vm._e(), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.actionData.actionType) + " completed on "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.actionData.completed_at)))]), _vm._v(" by "), _c('b', [_vm._v(_vm._s(_vm.actionData.completed_by))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac7a34dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/workflow/CompletedRequest.vue
// module id = 1691
// module chunks = 0